import { render, staticRenderFns } from "./BotaoCertificacao.vue?vue&type=template&id=3ab1183f&lang=pug"
import script from "./BotaoCertificacao.vue?vue&type=script&lang=js"
export * from "./BotaoCertificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports